/* import __COLOCATED_TEMPLATE__ from './lsg-badge.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

const COLORS = {
  BLACK: 'black',
  GRAY: 'gray',
  RED: 'red',
  YELLOW: 'yellow',
};

export const LSG_BADGE = {
  COLORS,
};

const CLASS_NAME = 'LSG-c-badge';

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: '',
  CLASS_NAME,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /**
   * @param {String} Color
   */
  color: LSG_BADGE.COLORS.BLACK,

  /** @param {String} */
  label: '',

  /**
   * @param {Boolean} isSmall Whether to render the small version.
   */
  isSmall: false,

  /*********************************
   * PRIVATE
   **********************************/

  tagClass: computed(
    'color',
    'isSmall',
    function () {
      let tagClass = CLASS_NAME;

      if (this.get('isSmall')) {
        tagClass += ` ${CLASS_NAME}--is-small`;
      }

      tagClass += ` ${CLASS_NAME}--${this.get('color')}`;

      return tagClass;
    }
  ),
});
